import styled from 'styled-components';

export const Par = styled.div`
  padding: 0;
  margin: 0;
  font-size: 1.5rem;
  width: 100%;
`;
